// src/services/pushService.js
import { PushNotifications } from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm';
import { Capacitor } from '@capacitor/core'; // <--- Importamos Capacitor para detectar la plataforma
import { ficharService } from './ficharService';

/**
 * Inicializa Push Notifications y actualiza el token en el backend
 * @param {string} userId - ID del usuario actual
 * @returns {Promise<boolean>} - true si se inicializó correctamente, false si falló o no hay permisos
 */
export const initPushService = async (userId) => {
  if (!userId) {
    console.warn('⚠️ initPushService: Se requiere userId para registrar token FCM');
    return false;
  }

  // 1. Verificación de Plataforma: Si es Web, salimos temprano para evitar el error de plugin no implementado
  if (Capacitor.getPlatform() === 'web') {
    console.info('ℹ️ Push Notifications: No disponibles en entorno Web (esperado).');
    return false; 
  }

  try {
    console.log('🟢 Inicializando Push Notifications en dispositivo nativo...');

    // 2. Solicitar permisos al sistema operativo
    const permission = await PushNotifications.requestPermissions();
    
    if (permission.receive !== 'granted') {
      console.warn('🚫 Permisos de notificación denegados por el usuario.');
      return false; 
    }

    // 3. Registrar el dispositivo en el servicio de notificaciones de Apple/Google
    await PushNotifications.register();

    // 4. Obtener el token FCM (Firebase Cloud Messaging)
    try {
      const tokenData = await FCM.getToken();
      const token = tokenData.token;
      
      console.log('✅ Token FCM obtenido:', token);

      // 5. Guardar token en el backend
      await ficharService.updateApkId({
        id: userId,
        idapk: token,
      });
      
      console.log('✅ Token sincronizado con el servidor');
    } catch (err) {
      console.error('❌ Error al obtener o guardar el token FCM:', err);
      return false; 
    }

    // --- Listeners de Eventos ---

    // Remover listeners previos para evitar duplicidad si se reintenta
    await PushNotifications.removeAllListeners();

    PushNotifications.addListener('registrationError', (error) => {
      console.error('❌ Error nativo al registrar notificaciones:', error);
    });

    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('📩 Notificación recibida en primer plano:', notification);
      window.location.reload();
    });

    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      console.log('➡️ Usuario abrió la notificación:', action.notification);
      window.location.reload();
    });

    return true; 

  } catch (err) {
    console.error('❌ Error general en initPushService:', err);
    return false;
  }
};